module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-3b862e2efed44ca1e943b870533af6c6.png";